export const DEPARTMENTS = [
  'IT',
  'Finance',
  'Human Resources',
  'Operations',
  'Engineering',
  'Recruitment',
  'Sales',
];
